const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时更新',
    desc: '编辑团队7×24小时追踪全网娱乐热点，第一时间同步最新瓜讯，重要事件绝不遗漏。',
  },
  {
    icon: 'ri-links-line',
    title: '多入口导航',
    desc: '聚合91吃瓜网、在线版、官网等多条访问入口，一处收藏永久直达，再也不怕网址失效。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全设备适配',
    desc: 'PC端、手机网页版全面优化，无论在家用电脑还是出门用手机，都能顺畅浏览吃瓜内容。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '严格的内容审核机制与用户隐私保护，为你营造一个安全放心的吃瓜环境。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-2">
          为什么选择91吃瓜
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">吃瓜平台的核心优势，让你的吃瓜体验更畅快</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => (
            <div key={i} className="text-center p-6 bg-background-100 rounded-lg border border-background-200/70 hover:border-primary-200/50 transition-all">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}